module.exports = __webpack_public_path__ + "img/attach_file.5f67fd3e.svg";